import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'influencer-home-order-bar',
  templateUrl: './influencer-home-order-bar.component.html',
  styleUrls: ['./influencer-home-order-bar.component.scss']
})
export class DashboardOrderBarComponent {

  @Input() discoverFilter: any;
  @Output() eventOrderList: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  onOrderBy(field) {
    this.eventOrderList.emit(field);
  }

  hasOrderBy(orderField) {
    if (!this.discoverFilter.orderBy) {
      return false;
    }
    return this.discoverFilter.orderBy === orderField;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer-home/influencer-home-order-bar/influencer-home-order-bar.component.ts